import { create } from 'zustand'
import type { SimulationResult } from '@/types'
import { runAllSimulations } from '@/engine/simulation'
import type { Debt } from '@/types'

interface SimulationState {
  results: {
    avalanche: SimulationResult | null
    snowball: SimulationResult | null
    hybrid: SimulationResult | null
    minimum_only: SimulationResult | null
  }
  totalMonthlyBudget: number
  isCalculating: boolean
  lastComputedAt: string | null
}

interface SimulationActions {
  runSimulations: (debts: Debt[], extraMonthlyPayment: number) => void
}

export const useSimulationStore = create<SimulationState & SimulationActions>()((set) => ({
  results: {
    avalanche: null,
    snowball: null,
    hybrid: null,
    minimum_only: null,
  },
  totalMonthlyBudget: 0,
  isCalculating: false,
  lastComputedAt: null,

  runSimulations: (debts, extraMonthlyPayment) => {
    set({ isCalculating: true })
    // Use requestIdleCallback if available to avoid blocking UI
    const compute = () => {
      const { avalanche, snowball, hybrid, minimum_only, totalMonthlyBudget } = runAllSimulations(
        debts,
        extraMonthlyPayment
      )
      set({
        results: { avalanche, snowball, hybrid, minimum_only },
        totalMonthlyBudget,
        isCalculating: false,
        lastComputedAt: new Date().toISOString(),
      })
    }

    if (typeof requestIdleCallback !== 'undefined') {
      requestIdleCallback(compute, { timeout: 500 })
    } else {
      setTimeout(compute, 0)
    }
  },
}))
